module.exports = __webpack_public_path__ + "assets/img/title-389ea445.png";